import {filter} from 'lodash';
import memoize from 'lru-memoize';
import memoizeOne from 'memoize-one';

import {InboxModel} from '../../../../libs/shared/core/src/models/api/inboxModel';
import {doesInboxMatchQuery} from '../../../../libs/shared/core/src/models/helpers/inboxHelpers';

/*
 * Constants.
 */

export const fetchInboxesPageSize = 50;

/*
 * Helpers.
 */

export const filterInboxes = memoize(20)((inboxes: ReadonlyArray<InboxModel>, query: string) => {
  // Shortcut for empty query.
  if (!query) {
    return inboxes;
  }

  // Otherwise, filter by name.
  return filter(inboxes, (i) => doesInboxMatchQuery(i, query));
});

export const findInboxNameDuplicates = memoizeOne((inboxes: ReadonlyArray<InboxModel>) => {
  const inboxNames = new Set<string>();
  const inboxNameDuplicates = new Set<string>();

  // Loop on all the inboxes to find the ones with duplicate names.
  inboxes.forEach((inbox) => {
    if (!inbox) {
      return;
    }

    if (inboxNames.has(inbox.name)) {
      inboxNameDuplicates.add(inbox.name);
      return;
    }

    inboxNames.add(inbox.name);
  });

  return inboxNameDuplicates;
});
